import dateformat from 'dateformat';
import { SeparationType } from '../../enums/SeparationType';
import { OrderForListing } from '../../models/OrderForListing';
import { IWidthColumnOrdersTable } from './useOrdersTable';
import { TableData } from './styles';

interface IRecipeTableDataProps {
  separationType?: SeparationType;
  orderForListing: OrderForListing;
  widthColumn: IWidthColumnOrdersTable;
  backgroundColor?: string;
}

export const RecipeTableData: React.FC<IRecipeTableDataProps> = ({
  separationType,
  orderForListing,
  widthColumn,
  backgroundColor
}) => {
  
  let cellValue = '';
  if (separationType === SeparationType.Prescription) {
    cellValue = orderForListing.firstRecipeApprovedAt ? dateformat(orderForListing.firstRecipeApprovedAt, 'dd/mm/yyyy') : '';
    if (!cellValue && 
        (orderForListing.order.onlyPlanLenses || 
          (orderForListing.order.totalFlatLensesCount &&
           orderForListing.order.totalFlatLensesCount > 0 && 
           orderForListing.order.totalFlatLensesCount === orderForListing.order.totalLensesCount
          )
        )
    ) {
      cellValue = 'N/A';
    }
  }

  return separationType === SeparationType.Prescription ?
    <TableData width={widthColumn.RecipeAt} backgroundColor={backgroundColor}>
      {cellValue}
    </TableData>
  : null;

}